import styled from 'styled-components/native';
import { colors } from '../../../../styles';

const MainContainer = styled.View`
  flex: 1;
  background-color: ${colors.white};
`;

export { MainContainer };
